export default __webpack_public_path__ + "static/media/group10.4154ea11.svg";